import { render, staticRenderFns } from "./addRoulette.vue?vue&type=template&id=46dba912&"
import script from "./addRoulette.vue?vue&type=script&lang=js&"
export * from "./addRoulette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports